(function () {
  if (window.__ifa2026ScrollInit) {
    if (typeof window.__ifa2026ScrollBind === 'function') {
      window.__ifa2026ScrollBind();
    }
    return;
  }

  window.__ifa2026ScrollInit = true;

  var sectionIds = ['retail-opportunity', 'how-it-works', 'playermaker-20-video', 'follow-up-options'];

  function scrollToSection(id) {
    var target = document.getElementById(id);
    if (!target) return false;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + id);
    }

    return true;
  }

  function resolveSectionId(trigger) {
    if (!trigger) return '';

    var id = trigger.getAttribute('data-ifa2026-scroll');
    if (id) return id;

    var href = trigger.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return '';

    return decodeURIComponent(href.slice(1));
  }

  function onScrollTriggerClick(event) {
    var id = resolveSectionId(event.currentTarget);
    if (sectionIds.indexOf(id) === -1) return;

    var target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();

    if (!scrollToSection(id)) {
      window.location.hash = id;
    }
  }

  function bindScrollTriggers() {
    sectionIds.forEach(function (id) {
      document
        .querySelectorAll('[data-ifa2026-scroll="' + id + '"], a[href="#' + id + '"]')
        .forEach(function (trigger) {
          if (trigger.__ifa2026ScrollBound) return;
          trigger.__ifa2026ScrollBound = true;
          trigger.addEventListener('click', onScrollTriggerClick);
        });
    });
  }

  function init() {
    bindScrollTriggers();

    if (!window.location.hash) return;

    var initialId = decodeURIComponent(window.location.hash.slice(1));
    if (sectionIds.indexOf(initialId) === -1) return;

    setTimeout(function () {
      scrollToSection(initialId);
    }, 150);
  }

  window.__ifa2026ScrollBind = bindScrollTriggers;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', bindScrollTriggers);
  document.addEventListener('shopify:section:load', init);
})();
